/* eslint-disable */
export default {
  unknown: 'Inconnu',
  multipleMatches: 'Plusieurs correspondances',
  anonymous: 'Anonyme',
  none: 'Aucun',
} as const;

// @key: @#@"unknown"@#@ @source: @#@"Unknown"@#@
// @key: @#@"multipleMatches"@#@ @source: @#@"Multiple matches"@#@
// @key: @#@"anonymous"@#@ @source: @#@"Anonymous"@#@
// @key: @#@"none"@#@ @source: @#@"None"@#@
